import React from 'react';

import { QuestionNumberRange, QuestionTypeV2 } from '../../../redux/types';
import TextQuestionEditor from '../TextQuestionEditor';

export type Props = {
  surveyId: number;
  sectionId?: number;
  question?: QuestionNumberRange;
  addQuestion?: (dq: Omit<QuestionNumberRange, 'id'>) => void
  updateQuestion?: (dq: QuestionNumberRange) => void
  onCancelEdit?: () => void;
  disableHideAggregation?: boolean;
}

const RangeQuestionEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  question,
  addQuestion,
  updateQuestion,
  onCancelEdit,
  disableHideAggregation,
}: Props) => (
  <TextQuestionEditor<QuestionNumberRange>
    type={QuestionTypeV2.NumberRange}
    surveyId={surveyId}
    sectionId={sectionId}
    question={question}
    addQuestion={addQuestion}
    updateQuestion={updateQuestion}
    onCancelEdit={onCancelEdit}
    disableHideAggregation={disableHideAggregation}
  />
);

export default RangeQuestionEditor;
